import React, { Suspense } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { Stack } from '@mui/material'

type ChunkLoaderProps = {
	children: React.ReactNode
}

export default function ChunkLoader({ children }: ChunkLoaderProps) {
	return (
		<Suspense
			fallback={
				<Stack justifyContent="center" height="300px" alignItems="center">
					<CircularProgress />
				</Stack>
			}
		>
			{children}
		</Suspense>
	)
}
